import type React from 'react';

import { Grid } from '@change/ds-layout';

import { INFO_CARD_LINKS } from '#src/app/pages/about/main/shared/consts';

import { InfoCardLink } from './components/InfoCardLink';

export const InfoCards: React.FC<EmptyProps> = () => {
	return (
		<Grid className="mt-8 mb-16">
			{INFO_CARD_LINKS.map((infoCard) => (
				<div
					key={infoCard.icon}
					className="col-span-4 md:col-span-4 md:mb-20 lg:col-span-4 lg:col-start-3 lg:first:col-start-3 lg:last:col-start-7"
				>
					<InfoCardLink {...infoCard} data-qa="about-info-card-link" />
				</div>
			))}
		</Grid>
	);
};
